import { COLORS, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Title = styled.label`
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  color: ${COLORS.BLACK};
  margin-bottom: 20rem;
  display: inline-block;

  ${respondTo.bigTablet`
    font-size: 20rem;
  `}

  ${respondTo.smallTablet`
    font-size: 18rem;
    margin-bottom: 10rem;
  `}
`;

export const InputWrapper = styled.div`
  width: 435rem;

  ${respondTo.bigTablet`
    width: 250rem;
  `}

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;

/*
 * The modal itself never scrolls (see modalStyle in ColorModal.tsx): it is a
 * flex column, so FirstRow stays put at every width and only ScrollArea moves.
 */
export const Container = styled.div`
  padding: ${paddingMd};
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  ${respondTo.bigPhone`
    padding-top: 40rem;
  `}
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /* Do not chain the scroll to the page behind the modal. */
  overscroll-behavior: contain;
  /* Room for the cards' outer box-shadow border, which overflow would clip. */
  padding: 0 3rem 3rem;
  margin: 0 -3rem;
`;

export const FirstRow = styled.div`
  display: flex;
  flex-shrink: 0;
  border-bottom: 1px solid ${COLORS.BORDER};
  padding-bottom: 10rem;
  margin-bottom: 10rem;

  ${respondTo.smallTablet`
    flex-direction: column;
  `}
`;

export const Divider = styled.div`
  height: 110rem;
  width: 1rem;
  background-color: ${COLORS.BORDER};
  margin-left: 30rem;
  margin-right: 30rem;

  ${respondTo.smallTablet`
    display: none;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${respondTo.smallTablet`
    margin-bottom: 10rem;

    &:first-of-type {
      padding-bottom: 20rem;
      border-bottom: 1px solid ${COLORS.BORDER};
    }
  `}
`;

export const PopularSection = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${COLORS.BORDER};
`;

export const ResultsSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GridWrap = styled.div`
  display: grid;
  grid-gap: 30rem;
  justify-content: space-between;
  grid-template-columns: repeat(4, minmax(0, 1fr));

  ${respondTo.horizontalTablet`
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `}

  ${respondTo.midTablet`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `}

  ${respondTo.bigPhone`
    display: flex;
    flex-direction: column;
    gap: 30rem;
    justify-content: center;
    align-items: center;
  `}
`;

export const PopularFlexWrap = styled.div`
  display: flex;
  gap: 20rem;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 20rem;
  flex-wrap: wrap;

  ${respondTo.bigPhone`
    justify-content: center;
  `}
`;

export const SelectWrapper = styled.div`
  width: 435rem;

  ${respondTo.bigTablet`
    width: 250rem;
  `}

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;
